import React, {Component} from 'react'
import {Button, Tabs, message, Popconfirm} from 'antd';
import {reqImportOrder,} from '../../api'
import OrderShortInfoView from "../import-delivery-info/import-track-short-info-v";
import OrderRemarkView from "./order-remark-view";
import ImportOrderView from "./import-order-view";
import ImportOrderFile from './import-order-file'

const {TabPane} = Tabs;

class ImportOrderInfoView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            order: {},
            orderId: null,
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.setState({orderId})
        this.getImportOrder(orderId);
    }

    getImportOrder = async (id) => {
        let result = await reqImportOrder(id)
        if (result.code === 200) {
            this.setState({order: {entName: result.data.entName, ...result.data.orderDelivery, ...result.data.orderDo}})
        } else {
            message.error(result.message)
        }
    }
    callback = (key) => {
        const {orderId} = this.state;
        this.props.history.push(key, {orderId: orderId})
        this.setState({activeKey: key})
    }
    //委托单保存重新加载订单数据
    refreshData = () => {
        const {orderId} = this.state;
        this.getImportOrder(orderId);
    };

    render() {
        const {order, orderId,} = this.state;
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                    </div>
                </div>
                <OrderShortInfoView order={order} entName={order.entName}/>
                <OrderRemarkView orderId={orderId}/>
                <div className='order-info-tab order-info-content' style={{
                    padding: '5px 20px 0 20px',
                    borderTop: '1px solid #ededed',
                }}>
                    <Tabs tabBarGutter={'16px'}>
                        <TabPane tab="委托单" key="/import/orderView">
                            <ImportOrderView history={this.props.history} order={order}
                                             refreshData={this.refreshData}/>
                        </TabPane>
                        <TabPane tab="照片" key="/import/orderView/file">
                            <ImportOrderFile history={this.props.history} orderId={orderId} readonly={true}/>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default ImportOrderInfoView